export default __webpack_public_path__ + "static/media/CreditCounselingImage.69da5ec5.svg";